import React from "react";
import { Button } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

interface FakeSendButtonProps {
  onClick: () => void;
}

/**
 * A visually identical "Send Email" button shown only during the demo walkthrough.
 * This component has ZERO imports from email services or API modules.
 * The onClick callback navigates to the client tracking view — it never sends email.
 */
const FakeSendButton: React.FC<FakeSendButtonProps> = ({ onClick }) => (
  <Button
    variant="contained"
    startIcon={<SendIcon />}
    onClick={onClick}
    data-tour="fake-send-btn"
    sx={{
      textTransform: "none",
      fontWeight: 600,
    }}
  >
    Send Email
  </Button>
);

export default FakeSendButton;
